/**
 * Table name helpers, ported from the POS client
 * (features/dine-in/floor-plan/tableNames.ts) so admin-created tables use the
 * same `T{n}` scheme and stay unique during bulk creation.
 */

/** Collect existing table name/displayName keys (case-insensitive). */
export const collectTakenTableNames = (tables = []) => {
  const taken = new Set();
  tables.forEach((table) => {
    const name = table?.tableDetails?.name?.trim();
    const displayName = table?.tableDetails?.displayName?.trim();
    if (name) {
      taken.add(name.toLowerCase());
    }
    if (displayName) {
      taken.add(displayName.toLowerCase());
    }
  });
  return taken;
};

/**
 * Next free `T{n}` name. Mutates `taken` so bulk creates stay unique in-loop
 * before catalog state refreshes.
 */
export const allocateNextTableName = (taken) => {
  let index = 1;
  while (taken.has(`t${index}`)) {
    index += 1;
  }
  const name = `T${index}`;
  taken.add(name.toLowerCase());
  return name;
};

/**
 * Unique copy name from a source label (`T3` → `T3-copy`, then `T3-copy-2`…).
 * Mutates `taken`.
 */
export const allocateUniqueCopyName = (taken, sourceLabel) => {
  const base = `${(sourceLabel || 'T').trim() || 'T'}-copy`;
  if (!taken.has(base.toLowerCase())) {
    taken.add(base.toLowerCase());
    return base;
  }
  let suffix = 2;
  let candidate = `${base}-${suffix}`;
  while (taken.has(candidate.toLowerCase())) {
    suffix += 1;
    candidate = `${base}-${suffix}`;
  }
  taken.add(candidate.toLowerCase());
  return candidate;
};
